import PropTypes from 'prop-types';

export const ExternalSourcePropTypes = {
  type: PropTypes.oneOf(['link', 'pdf', 'image', 'video', 'component', 'notype']),
  body: PropTypes.string.isRequired,
  url: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  indent: PropTypes.number,
};

export default PropTypes.shape(ExternalSourcePropTypes);



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/ExternalSourceShape.js